import { createTheme, responsiveFontSizes } from "@mui/material/styles";

/**
 * Global responsive theme (MUI v5).
 *
 * Breakpoints are tuned so the app adapts when the browser zoom level
 * changes, because zoom changes the effective CSS viewport width:
 *   1920px monitor @ 100% zoom -> 1920px viewport (xl/xxl)
 *   1920px monitor @  85% zoom -> ~2260px viewport (xxl)
 *   1920px monitor @  75% zoom -> 2560px viewport (xxxl)
 *   1366/1536px laptops        -> lg / xl
 *
 * This theme is additive: screens that create their own local themes
 * (LoginForm2, LandingPageMain, ...) still override it via their nested
 * ThemeProvider, so no existing logic or look is lost.
 */
let responsiveTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1920, // full-HD at 100% zoom
      xxxl: 2560, // full-HD at 75% zoom / 2K+ monitors
    },
  },
  typography: {
    fontFamily: '"Roboto-Regular", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    // Keep dialogs/popovers inside the viewport at every zoom level.
    MuiDialog: {
      styleOverrides: {
        paper: {
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "calc(100vh - 32px)",
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          maxWidth: "calc(100vw - 32px)",
        },
      },
    },
    // Tables and data grids scroll inside their own container instead of
    // pushing the page sideways when the effective viewport shrinks.
    MuiTableContainer: {
      styleOverrides: {
        root: {
          overflowX: "auto",
          maxWidth: "100%",
        },
      },
    },
  },
});

// Scale MUI typography (h1..caption, buttons, ...) fluidly between
// breakpoints so text stays proportionate at 75% / 85% / 100% zoom.
responsiveTheme = responsiveFontSizes(responsiveTheme, {
  breakpoints: ["sm", "md", "lg", "xl"],
  factor: 2,
});

export default responsiveTheme;
